// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Cl2m","icon":"styles_icon__1DDSg"};